module.exports = __webpack_public_path__ + "assets/stripe-logo.ec1e47ca.svg";